/*
 * @FileAuthor: ghy
 * @Date: 2023-08-08 14:48:05
 * @Description: 插件方法、事件初始化
 */

const initApiMethods = require('./methods');

/**
 * @description 初始化方法、事件
 * @param {Object} Ext 插件实例
 */
const initApi = (Ext) => {
  initApiMethods(Ext);
};

module.exports = initApi;
